import React from "react";
import PageTemplate from "../components/PageTemplate";

function Desserts() {
  return (
    <PageTemplate title="Desserts">
      <p>Sweet finishes and sugar dreams — dessert ideas coming soon!</p>
    </PageTemplate>
  );
}

export default Desserts;
